const itemListIdMixin = {
  data() {
    return {
      itemListId: null
    }
  },
  methods: {
    async updateItemListId() {
      if (typeof this.$el?.closest !== 'function') return
      const { HTML_CUSTOM_ATTRIBUTES } = await import(
        '@/constants/GlobalConstants'
      )
      const listElement = this.$el.closest(
        '[' + HTML_CUSTOM_ATTRIBUTES.ITEM_LIST_ID + ']'
      )
      this.itemListId = listElement?.getAttribute('item-list-id')
    }
  },
  mounted() {
    this.updateItemListId()
  },
  updated() {
    this.updateItemListId()
  }
}

export default itemListIdMixin
